import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getProjectAndSubProjectTilaajavastuuDocuments = async (
  projectId
) => {
  const apiPath = `project-bank/${projectId}/project-and-sub-projects/tilaajavastuu-documents`;

  const signedRequest = await createSignedGetRequest({ apiPath });

  const response = await axios(signedRequest);

  return response.data;
};
